'use client'
import React, { useEffect } from 'react'
import * as Features from '../features'
import { PageRenderer, useWhitelabeling } from '@develos/next-library'
import xhook from "xhook";
import { useGetPortalSettingsSubscritpion } from '@/store/portalSettings/api';

const AppRenderer = () => {
  const { applyWhitelabeling } = useWhitelabeling()
  useGetPortalSettingsSubscritpion();

  useEffect(() => {
    applyWhitelabeling()
    xhook.enable();
  }, [])
  
  return (
    <PageRenderer layouts={{}} features={Features} skins={{}} />
  )

}

export default AppRenderer
